import { render, staticRenderFns } from "./AmeldingFormWorkRelation.vue?vue&type=template&id=5aeb5e67&scoped=true&"
import script from "./AmeldingFormWorkRelation.vue?vue&type=script&lang=ts&"
export * from "./AmeldingFormWorkRelation.vue?vue&type=script&lang=ts&"
import style0 from "./AmeldingFormWorkRelation.vue?vue&type=style&index=0&id=5aeb5e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aeb5e67",
  null
  
)

export default component.exports